export const SOCIAL_PLATFORMS = ['instagram', 'tiktok', 'youtube', 'linkedin', 'facebook'] as const;

export type SocialPlatformType = (typeof SOCIAL_PLATFORMS)[number];

export const PLATFORM_CAPTION_LIMITS: Record<SocialPlatformType, number> = {
  instagram: 2200,
  tiktok: 2200,
  youtube: 5000,
  linkedin: 3000,
  facebook: 63206,
};

export const PLATFORM_REQUIRES_TITLE: Record<SocialPlatformType, boolean> = {
  instagram: false,
  tiktok: false,
  youtube: true,
  linkedin: false,
  facebook: false,
};
